<template>
  <div v-if="quote && Object.keys(quote).length">
    <!-- EXPANDED -->
    <v-slide-y-transition hide-on-leave>
      <div v-show="quote.shown">
        <!-- ONLY DESKTOP -->
        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          class="d-flex justify-space-between"
        >
          <!-- HIDE QUOTE -->
          <v-btn
            v-ripple="false"
            small
            color="white"
            class="elevation-1 remove-bottom-radius mx-4"
            @click="$emit('toggle-quote-shown', quote.id)"
          >
            <v-icon
              color="primary"
              :size="16"
              class="mr-1 mb-2px"
            >
              mdi-minus-circle-outline
            </v-icon>
            <span class="primary--text caption">
              Hide quote
            </span>
          </v-btn>
        </div>

        <v-card :class="{ 'offer-border': hasSpecialOffer }">
          <v-container fluid>
            <!-- DESKTOP -->
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-row class="flex-nowrap">
                <!-- Provider -->
                <v-col
                  class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light result-columns-align-width"
                >
                  <img
                    v-if="qd.imageSiteRemote"
                    :src="qd.imageSiteRemote"
                    :alt="qd.brokerFullName"
                    class="provider-logo"
                    @click="onClickViewDetails(quote)"
                  >
                  <div
                    v-else
                    class="font-weight-bold text-center"
                  >
                    {{ qd.brokerFullName }}
                  </div>
                  <results-price
                    v-if="isViewMonthly"
                    :quote="quote"
                    :monthly="!isViewMonthly"
                    :selected-optional-extras="selectedOptionalExtras"
                    class="info--text pt-2"
                    @open-more-info="onClickViewDetails(quote)"
                  />
                </v-col>
                <!-- Price -->
                <v-col
                  class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light result-columns-align-width"
                >
                  <results-price
                    :quote="quote"
                    :monthly="isViewMonthly"
                    :cashback="cashback"
                    :selected-optional-extras="selectedOptionalExtras"
                    @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
                    @open-more-info="onClickViewDetails(quote)"
                  />
                </v-col>

                <!-- Excess -->
                <v-col
                  class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light
                  text-center result-columns-align-width"
                >
                  <dl class="caption">
                    <div
                      v-if="!isCoverContentsOnly"
                      class="d-flex justify-space-between"
                    >
                      <dt class="mr-3">
                        Buildings
                      </dt>
                      <dd class="fs-10 font-weight-bold">
                        &pound;{{ buildingsExcess }}
                      </dd>
                    </div>
                    <div
                      v-if="!isCoverBuildingsOnly"
                      class="d-flex justify-space-between mb-2"
                    >
                      <dt class="mr-3">
                        Contents
                      </dt>
                      <dd class="fs-10 font-weight-bold">
                        &pound;{{ contentsExcess }}
                      </dd>
                    </div>
                  </dl>
                </v-col>

                <!-- Optional extras -->
                <v-col
                  v-for="extra of optionalExtrasColumns"
                  :key="extra.value"
                  class="d-flex flex-column justify-start align-center
                  table-right-border table-right-border-light
                  text-center result-columns-align-width"
                >
                  <results-optional-extra
                    :extra="qd.optionalExtra[extra.value]"
                    :selected="selectedOptionalExtras.includes(extra.value)"
                  />
                </v-col>

                <!-- Policy details -->
                <v-col
                  class="d-flex flex-column justify-center align-center text-center
                       result-columns-align-width"
                >
                  <v-btn
                    rounded
                    color="success"
                    @click="onClickViewDetails(quote)"
                  >
                    More info
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <!-- TABLETS/MOBILES -->
            <template v-else>
              <v-row class="mobile-quote-alignment">
                <!-- Provider -->
                <v-col
                  class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light pa-2
                  result-columns-align-width"
                >
                  <img
                    :src="qd.imageSiteRemote"
                    :alt="qd.brokerFullName"
                    class="provider-logo"
                    @click="onClickViewDetails(quote)"
                  >
                  <results-price
                    v-if="isViewMonthly"
                    :quote="quote"
                    :monthly="!isViewMonthly"
                    :selected-optional-extras="selectedOptionalExtras"
                    size="small"
                    class="info--text pt-2"
                    @open-more-info="onClickViewDetails(quote)"
                  />
                </v-col>

                <!-- Price -->
                <v-col
                  class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light pa-2
                  result-columns-align-width"
                >
                  <results-price
                    :quote="quote"
                    :monthly="isViewMonthly"
                    :cashback="cashback"
                    :selected-optional-extras="selectedOptionalExtras"
                    @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
                    @open-more-info="onClickViewDetails(quote)"
                  />
                </v-col>

                <!-- Policy details -->
                <v-col
                  class="d-flex flex-column justify-center align-center text-center pa-2
                        result-columns-align-width"
                >
                  <v-btn
                    rounded
                    :small="isViewMonthly"
                    color="success"
                    @click="onClickViewDetails(quote)"
                  >
                    More
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider class="mt-3" />

              <!-- Optional extras -->
              <v-row
                class="body-2 font-weight-medium text-left mt-3 fs-12"
                no-gutters
              >
                <v-col
                  v-for="(extra, index) of mobileExtras"
                  :key="extra.value"
                  cols="6"
                  :class="{even: index % 2}"
                >
                  <results-optional-extra-mobile
                    :title="extra.label"
                    :extra="qd.optionalExtra[extra.value]"
                    :selected="selectedOptionalExtra(extra)"
                  />
                </v-col>
              </v-row>
            </template>
          </v-container>
          <results-quote-expiry
            v-if="qd.quoteExpiryTime"
            :expire-time="qd.quoteExpiryTime"
            @open-more-info="onClickViewDetails(quote)"
          />
          <div
            v-if="hasSpecialOffer"
            class="accent-gradient caption py-2 px-3"
            style="margin-right: 0.5px;"
          >
            <v-icon
              small
              color="navy-dark"
              class="mr-2"
            >
              mdi-tag
            </v-icon>
            <span v-html="qd.companyConfig.featuredText" />
          </div>
          <div
            v-else-if="hasInfoText"
            class="caption py-2 px-3"
            style="margin-right: 0.5px;"
          >
            <v-icon
              small
              color="navy-dark"
              class="mr-2"
            >
              mdi-tag
            </v-icon>
            <span v-html="qd.specialOffer" />
          </div>
        </v-card>
      </div>
    </v-slide-y-transition>

    <!-- COLLAPSED -->
    <v-slide-y-reverse-transition hide-on-leave>
      <v-card
        v-show="!quote.shown"
        class="card"
      >
        <v-container fluid>
          <div class="d-flex align-items-center">
            <v-btn
              v-ripple="false"
              small
              color="white"
              depressed
              @click="$emit('toggle-quote-shown', quote.id)"
            >
              <v-icon
                color="primary"
                :size="16"
                class="mr-1 mb-2px"
              >
                mdi-plus-circle-outline
              </v-icon>
              <span class="primary--text caption">
                Show hidden quote
              </span>
            </v-btn>

            <img
              :src="qd.imageSiteRemote"
              :alt="qd.brokerFullName"
              class="hidden-quote-img px-4 mx-3"
            >

            <span class="title">
              <span v-html="calcAnnual" />
              <span class="caption ml-2 mb-0">per year</span>
            </span>
          </div>
        </v-container>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import ResultsPrice from '@/components/car/Results/ResultsPrice.vue';
import ResultsQuoteExpiry from '@/components/QuoteExpiry/ResultsQuoteExpiry.vue';
import ResultsOptionalExtra from '@/components/car/Results/ResultsOptionalExtra.vue';
import ResultsOptionalExtraMobile from '@/components/car/Results/ResultsOptionalExtraMobile.vue';
import { sortQuoteOptions } from '@/helpers/common';

export default {
  name: 'results-quote',
  components: {
    ResultsPrice,
    ResultsQuoteExpiry,
    ResultsOptionalExtra,
    ResultsOptionalExtraMobile,
  },
  inject: ['helpers'],
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    optionalExtrasColumns: {
      type: Array,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isCoverContentsOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCoverBuildingsOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    qd () {
      return this.quote.details[0];
    },
    calcAnnual () {
      return this.helpers.getPriceTemplate(this.qd.calcAnnual, 'subtitle-2');
    },
    hasSpecialOffer () {
      // proper special offers are listed in companyConfig / featuredText
      return !!this.qd.companyConfig && Object.keys(this.qd.companyConfig).length > 0;
    },
    hasInfoText () {
      // general info text (in json response as specialOffer)
      return !!this.qd.specialOffer && this.qd.specialOffer.length > 0;
    },
    mobileExtras () {
      return this.optionalExtrasColumns.filter(this.showOptionalExtra).sort(this.sortMobileExtras);
    },
    mobileExtrasUnselected () {
      return this.optionalExtrasColumns.filter(this.countAvailableOptionalExtra).length;
    },
    buildingsExcess () {
      return parseFloat(this.qd.buildCompulsoryExcess) +
        parseFloat(this.qd.buildVoluntaryExcess);
    },
    contentsExcess () {
      return parseFloat(this.qd.contentsCompulsoryExcess) +
        parseFloat(this.qd.contentsVoluntaryExcess);
    },
    cashback () {
      return +this.qd.cashback;
    },
  },
  methods: {
    onClickViewDetails (quote) {
      this.$emit('click-view-details', quote);
      this.$emit('open-drawer-details', ['results-details', 'optionalExtras']);
    },
    showOptionalExtra ({ value }) {
      return this.qd.optionalExtra[value].included !== 'N';
    },
    selectedOptionalExtra ({ value }) {
      return this.selectedOptionalExtras.includes(value) && this.qd.optionalExtra[value].cost !== null;
    },
    countAvailableOptionalExtra ({ value }) {
      return (!this.selectedOptionalExtras.includes(value) && this.qd.optionalExtra[value].cost !== null);
    },
    sortMobileExtras ({ value: keyOptionA }, { value: keyOptionB }) {
      const oA = this.qd.optionalExtra[keyOptionA].included;
      const oB = this.qd.optionalExtra[keyOptionB].included;
      return sortQuoteOptions(oA, oB);
    },
  },
};
</script>

<style scoped lang="scss">
.hidden-quote-img {
  height: 28px;
  border-left: 1px solid $clr-heather;
  border-right: 1px solid $clr-heather;
}

.provider-logo {
  display: block;
  max-width: 100%;
  height: auto;
}

.extras-disclaimer {
  @media screen and (max-width: 400px) {
    padding: 8px !important;
    margin-top: 5px !important;
    white-space: break-spaces !important;
    font-size: 12px;
  }
}

.mobile-quote-alignment {
  @media screen and (max-width: 400px) {
    .result-columns-align-width:first-of-type {
      flex-grow: 0;
      min-width: 108px;
    }
  }
}
</style>
<style scoped lang="scss" src='@/assets/scss/results/results-quote.scss' />
